import { Button, Checkbox, TableCell, TableCellProps, TableRow } from "@mui/material";
import dayjs from "dayjs";
import { Fragment, useState } from "react";
import { IInforme, TipoInformeNameResolver, estadoGeneralInforme, velocidades } from "../../../redux/models/typesInformes";
import { formatToCurrencyARS } from "../../../utils/allUtils";
import ActionButton from "../TableBase/ActionButton";
import UsuarioCellData from "../TableBase/UsuarioCell/UsuarioCell";
import { EnumActionsInforme } from "../TableBase/types";
import { hideKeysInforme } from "./TablaInformes";
import { obtenerNombreInforme } from "@/utils/informeUtils";


type MyTableCellProps = {
    children: React.ReactNode,
    align?: TableCellProps['align'],
    padding?: TableCellProps['padding']
    isDisabled?: boolean
    id?: TableCellProps['id']
    sx?: any
}

const MyTableCell = ({ children, align, padding, isDisabled, id, sx }: MyTableCellProps) => {
    return (
        isDisabled ? <></> :
            <TableCell
                align={align}
                padding={padding}
                id={id}
                sx={sx}
            >
                {children}
            </TableCell>
    )
}


type TablaInformesRowProps = {
    informe: IInforme,
    isSelected: boolean,
    labelId: string,
    hideColumns: hideKeysInforme
    onClickAction: (informe: IInforme, action: EnumActionsInforme) => void
    onClickSelect: (informe: IInforme) => void
}


const TablaInformesRowCells = ({ informe, isSelected, labelId, hideColumns, onClickViewInforme, onClickSelect }: {
    isSelected: boolean,
    informe: IInforme,
    labelId: string,
    hideColumns: hideKeysInforme,
    onClickViewInforme: (informe: IInforme, action: EnumActionsInforme) => void
    onClickSelect: (informe: IInforme) => void

}) => {
    return <Fragment>

        <MyTableCell padding="checkbox" isDisabled={hideColumns.includes('selectable')} >
            <Checkbox
                onChange={() => onClickSelect(informe)}
                color="primary"
                checked={isSelected}
                inputProps={{
                    'aria-labelledby': labelId,
                }}
            />
        </MyTableCell>
        <MyTableCell
            isDisabled={hideColumns.includes('idCarrito')}
            align="left"
            id={labelId}
        >
            {informe.id}
        </MyTableCell>
        <MyTableCell
            isDisabled={hideColumns.includes('tipo')}
            align="left"
        >
            { obtenerNombreInforme(informe, false, {velocidad: true })
}
        </MyTableCell>
        <MyTableCell
            isDisabled={hideColumns.includes('fechaDeCreacion')}
            align="left"
        >
            {dayjs(informe.fechaDeCreacion).format('DD/MM/YYYY')}
        </MyTableCell>
        <MyTableCell
            isDisabled={hideColumns.includes('velocidad')}
            align="left"
        >
            {velocidades[informe.velocidad]}

        </MyTableCell>
        <MyTableCell
            isDisabled={hideColumns.includes('precio')}
            align="left"
        >
            {formatToCurrencyARS(informe.precio)}
        </MyTableCell>
        <MyTableCell
            isDisabled={hideColumns.includes('usuario')}
            align="left"
        >
            {informe.usuario && <UsuarioCellData usuario={informe.usuario} />}
        </MyTableCell>
        <MyTableCell
            isDisabled={hideColumns.includes('estadoGeneral')}
            align="left">
            {estadoGeneralInforme[informe.estadoGeneral]}
        </MyTableCell>
        <MyTableCell
            isDisabled={hideColumns.includes('acciones')}
            align="center">


            <ActionButton
                title="Ver"
                onClick={() => onClickViewInforme(informe, EnumActionsInforme.VER)}
                icon="visibility"
                hide={hideColumns.includes('ACTION_SEE_INFORMES')}
            />

            <ActionButton
                title="Editar"
                onClick={() => onClickViewInforme(informe, EnumActionsInforme.EDITAR)}
                icon="edit"
                hide={hideColumns.includes('ACTION_EDITAR')}

            />

            <ActionButton
                title="Restaurar"
                onClick={() => onClickViewInforme(informe, EnumActionsInforme.RESTAURAR)}
                icon="restore"
                hide={hideColumns.includes('ACTION_RESTAURAR')}
            />


            <Button
                variant="contained"
                size="small"
                sx={{ display: hideColumns.includes('ACTION_LIQUIDAR') ? 'none' : 'inline' }}

                color="error"
            >
                Liquidar
            </Button>
        </MyTableCell>

    </Fragment>

}

const TablaInformesRow = ({ informe, isSelected, labelId, hideColumns, onClickAction: onClickViewInforme, onClickSelect }: TablaInformesRowProps) => {

    return (
        <TableRow
            hover
            role="checkbox"
            aria-checked={isSelected}
            tabIndex={-1}
            selected={isSelected}
            sx={(theme) => {
                return {
                    backgroundColor: informe.printed ? theme.palette.mode === 'light' ? '#dcffde' : '#263b2761' : 'inherit',
                }
            }}
        >

            <TablaInformesRowCells
                isSelected={isSelected}
                informe={informe}
                labelId={labelId}
                hideColumns={hideColumns}
                onClickViewInforme={onClickViewInforme}
                onClickSelect={onClickSelect}
            />

        </TableRow>
    );
}

export { TablaInformesRowCells }
export default TablaInformesRow;